/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const EvaluationStateForResult = {
    WithoutEvaluation: 'WithoutEvaluation',
    Passed: 'Passed',
    Warning: 'Warning',
    Failed: 'Failed',
    Open: 'Open'
} as const;
export type EvaluationStateForResult = typeof EvaluationStateForResult[keyof typeof EvaluationStateForResult];


export function EvaluationStateForResultFromJSON(json: any): EvaluationStateForResult {
    return EvaluationStateForResultFromJSONTyped(json, false);
}

export function EvaluationStateForResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): EvaluationStateForResult {
    return json as EvaluationStateForResult;
}

export function EvaluationStateForResultToJSON(value?: EvaluationStateForResult | null): any {
    return value as any;
}

/**
 * Check if a given object implements the EvaluationStateForResult interface.
 */
 export function instanceOfEvaluationStateForResult(value: any): value is EvaluationStateForResult {
    return Object.values(EvaluationStateForResult).includes(value)
}

